
    import Vue from 'vue';
    import { defineComponent } from 'vue';
    import XBreadcrumb from '../../components/Breadcrumb.vue';
    import checkPricingService from '@/apps/shared/services/checkPricing-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    export default defineComponent({
        components: {
            XBreadcrumb,
        },
        data() {
            return {
                premioMensual: null,
                coberturas: null,
                dataCovers: [],
                data: [],
                selectedValue: null,
                AmparoJson: null,
                QuotationJson: null,
                amparoTypesDescription: null,
                selectedPlan: null,
                dataQ: [],
                col: 2,
                col2: 1,
                plansLength: null,
                reload: true,
                breadcrumItems: [
                    { text: 'Inicio', path: '/movilidad' },
                    { text: 'Cotizador de Movilidad', path: '/movilidad/cotizarMovilidad' },
                    { text: 'Valor del Vehiculo', path: '/movilidad/valorVehiculo' },
                    { text: 'Elegi Plan', path: '/valorVehiculo/elegiPlan' },
                ],
                tabOneWelcome: null,
                dataVehicle: null,
                rangeSelected: null,
                leadId: null
            }
        },
        methods: {
            selectedPlans: function (quotationData) {                
                // se le envia el pricingId del plan que se haya elegido
                var pricingId = parseInt(quotationData.PricingId[0])
                sessionStorage.setItem("PlanSelected", JSON.stringify(quotationData));
                checkPricingService.checkStatePricing(pricingId).then(response => {
                    if (response.errorMessage == "Actualizacion correcta") {
                        sessionStorage.setItem("ExitOrContinueModal", "false")
                        window.location.href = '../movilidad/datosCliente' + "?cotizacion=" + pricingId;
                    }
                    else {
                        window.globalThis.dataLayer.push({ 'product': 'movilidad', 'event': 'errorServidor', 'paso': 'cotizador-movilidad-plan' });
                    }
                });
            },
            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'range-view',
                })
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },
            dataAmparos: function () {
                this.dataQ = [];
                var AmparosData = sessionStorage.getItem("ResponseAmparos");
                var DataQuotation = sessionStorage.getItem("DataQuotation");
                if (AmparosData != null) {
                    this.AmparoJson = JSON.parse(AmparosData!);
                    this.plansLength = this.AmparoJson.length;
                    this.QuotationJson = JSON.parse(DataQuotation!);
                    this.QuotationJson.forEach(o => {
                        var body = {
                            finallyCalculationResult: o.plans[0].finallyCalculationResult,
                            premioMensual: o.plans[0].premioMensual,
                            premiumWithoutDiscount: o.plans[0].premiumWithoutDiscount,
                            rate: o.plans[0].discounts == null ? null : o.plans[0].discounts[0].rate,
                            premioSegunVigencia: o.plans[0].premioSegunVigencia,
                            PricingId: o.plans[0].pricingId,
                            RelationId: o.relationId
                        }
                        this.dataQ.push(body)
                    })
                    for (var i = 0; i < this.AmparoJson.length; i++) {
                        var groupOfAmparoTheftOptions = [];
                        Object.assign(this.AmparoJson[i], this.dataQ[i])
                        var value = JSON.parse(JSON.stringify(this.AmparoJson[i]));
                        for (var a = 0; a < value.amparoTheftOptions.length; a++) {
                            if (groupOfAmparoTheftOptions.filter(resp => resp["amparoTypes"] == value.amparoTheftOptions[a]["amparoTypes"]).length == 0) {
                                var body = {
                                    amparoTypes: value.amparoTheftOptions[a]["amparoTypes"],
                                    amparoTypesDescription: value.amparoTheftOptions[a]["amparoTypesDescription"],
                                    capital: value.amparoTheftOptions[a]["capital"],
                                    amparoTypesNotes: value.amparoTheftOptions[a]["amparoTypesNotes"],
                                }
                                groupOfAmparoTheftOptions.push(body);
                            }
                        }
                        Object.assign(this.AmparoJson[i], { groupOfAmparoTheftOptions: groupOfAmparoTheftOptions });
                        NF.UI.Page.unblock();
                        this.AmparoJson[i].value = JSON.parse(JSON.stringify(this.AmparoJson[i]));
                        this.coberturas = groupOfAmparoTheftOptions;
                        this.premioMensual = this.AmparoJson[i].premioMensual;
                    }
                }
            },
        },
        mounted() {
            this.tabOneWelcome = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
            this.dataVehicle = JSON.parse(sessionStorage.getItem("DataVehicle"));
            this.rangeSelected = JSON.parse(sessionStorage.getItem("rangeSelected"));
            this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
            const additionalInformation = {
                'Producto': this.dataVehicle.vehTypeDescription,
                'Suma asegurada': this.rangeSelected.descriptionRange,
            };
            CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.tabOneWelcome.email, location.href, this.tabOneWelcome.areaCode, this.tabOneWelcome.telephone, 936, false, "4", additionalInformation, this.tabOneWelcome.lastName, this.tabOneWelcome.name);

            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
            window.globalThis.dataLayer.push({ 'product': 'movilidad', 'event': 'cotizador-movilidad-valor' });
            sessionStorage.removeItem("pressBack");
            var fromTabThree = sessionStorage.getItem("FromTabThree");
            var fromTabFour = sessionStorage.getItem("FromTabFour");
            NF.UI.Page.block();
            this.dataAmparos();
            if (fromTabThree == "true" && fromTabFour == "true") {
                sessionStorage.setItem("FromTabThree", "false");
                location.reload();
            } else {
                sessionStorage.setItem("FromTabThree", "false");
                sessionStorage.setItem("FromTabFour", "true");
            }
        }
    })
